<article class="privacy-page">
  <a routerLink="/" class="back-link">Home</a>

  <h1>Privacy policy</h1>
  <p class="meta">Last updated: {{ lastUpdated }}</p>

  <p class="lead">
    This page describes how this portfolio site (“the site”) handles personal information when you browse or use sign-in features.
  </p>

  <h2>Who is responsible</h2>
  <p>
    The site is operated by {{ siteOwnerName }}. For privacy-related requests, contact {{ contactEmail }}.
  </p>

  <h2>What we process</h2>
  <ul>
    <li>
      <strong>Portfolio content.</strong> Project descriptions and media are served from Firebase (Firestore and Cloud Storage) when you view the site.
    </li>
    <li>
      <strong>Optional sign-in.</strong> If you use “Private” / login, we use <strong>Firebase Authentication</strong>. You may sign in with Google or request a magic link by email. Google and Firebase process authentication data according to their terms and privacy policies.
    </li>
    <li>
      <strong>Magic link flow.</strong> While completing email sign-in, your email may be stored in the browser’s <strong>local storage</strong> temporarily to finish the flow, then removed when appropriate.
    </li>
    <li>
      <strong>Contact.</strong> The Contact page offers mailto and external links (e.g. LinkedIn). Opening those is between you and those services; this site does not run a separate contact form that stores your message on our servers.
    </li>
  </ul>

  <h2>Why we process it</h2>
  <p>
    To display the portfolio, allow optional access to hidden projects after authentication, and let site administrators manage content. We do not use third-party advertising or analytics scripts in the application at this time; if that changes, this policy will be updated and, where required, we will ask for consent before loading non-essential tracking.
  </p>

  <h2>Cookies and similar technologies</h2>
  <p>
    Firebase Authentication and the hosting platform may use cookies or local storage as needed for security and session management. There is no cookie banner solely for essential operation of the site; a separate consent mechanism may be added if non-essential cookies or trackers are introduced later.
  </p>

  <h2>Retention</h2>
  <p>
    Authentication and project data are kept as long as needed to operate the service and as governed by Firebase/Google retention. You may delete your reliance on sign-in by signing out; account data at Google/Firebase is subject to their tools and policies.
  </p>

  <h2>Your rights (EEA/UK)</h2>
  <p>
    If applicable law grants you rights of access, rectification, erasure, restriction, portability, or objection, you may exercise them by contacting {{ contactEmail }}. You may also lodge a complaint with your local supervisory authority.
  </p>

  <h2>International transfers</h2>
  <p>
    Firebase/Google may process data in the United States and other regions. Google provides appropriate safeguards as described in their documentation.
  </p>

  <h2>Changes</h2>
  <p>
    We may update this policy; the “Last updated” date above will change when we do. Continued use of the site after changes means you accept the updated policy.
  </p>
</article>
